import React from "react";
import ReusableModal from "components/Modals/ReusableModal";

const DeletePackagePlanModal = ({ isOpen, onClose, onConfirm, plan }) => {
  if (!plan) return null;

  const bodyMessage = `Are you sure you want to delete the package plan "<strong>${plan.name}</strong>"? This action cannot be undone.`;

  return (
    <ReusableModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      title="Confirm Delete"
      bodyMessage={<div dangerouslySetInnerHTML={{ __html: bodyMessage }} />}
      confirmLabel="Delete"
      cancelLabel="Cancel"
    />
  );
};

export default DeletePackagePlanModal;
